import React, { useState } from 'react';
import { KoForm, KoButton, KoDataTableEdit, KoNano } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './curd.module.scss';

function TaxCrud({ form, settings }) {
  let ds=  settings?.tax?.length > 0 ? settings?.tax :  [{
    key: KoNano('VNT'),
    type: '',
    variation: '',
    price: '',
    quantity:''
  }];
  const [dataSource, setDataSource] = useState(ds);
 
  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    if(newData.length === 0){
      newData =[{
        key: KoNano('VNT'),
        type: '',
        variation: '',
        price: '',
        quantity:''
      }];
    }
    handleSave(newData);
  };

  const columns = [
    {
      dataIndex: 'type',
      title: 'Variation Type',
      width: 200,
      editable: true,
      widget: 'options',
      placeholder: 'Select variation type',
      options: [
        { label: 'H1', value: 1 },
        { label: 'H2', value: 2 },
        { label: 'H3', value: 3 },
        { label: 'H4', value: 4 },
        { label: 'H5', value: 5 }
      ]
    },
    {
      dataIndex: 'variation',
      title: 'Variation',
      editable: true,
      widget: 'options',
      placeholder: 'Select variation',
      options: [
        { label: 'H1', value: 1 },
        { label: 'H2', value: 2 },
        { label: 'H3', value: 3 },
        { label: 'H4', value: 4 },
        { label: 'H5', value: 5 }
      ],
      width: 200
    },
    {
      dataIndex: 'price',
      title: 'Price',
      editable: true,
      widget: 'number',
      width: 200,
      placeholder: 'Price'
    },
    {
      dataIndex: 'quantity',
      title: 'Quantity',
      editable: true,
      widget: 'number',
      width: 200,
      placeholder: 'Quantity'
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      fixed:'right',
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />} className={styles.actionBtn} onClick={() => handleDelete(record?.key)} label="" />
            {dataSource?.length === (i+1) && <KoButton icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />} className={styles.actionBtn} onClick={() => handleAdd(record?.key)} label={``} />}
          </div>
        ) : null
    }
  ];

  const handleAdd = () => {
    const newData = {
      key: KoNano('VNT'),
      type: '',
      variation: '',
      price: '',
      quantity:''
    };
    setDataSource([...dataSource, newData]);
  };


  const handleSave = (newData) => {
    let data = form.getFieldsValue();
    data['tax'] = newData;
    form.setFieldsValue({...data});
    setDataSource(newData);
  };

  return (
    <div className={styles.wrapper}>
      <KoForm.Item name={'tax'}>
        <KoDataTableEdit
          dataSource={dataSource}
          form={form}
          onSave={handleSave}
          defaultColumns={columns} />
      </KoForm.Item>
    </div>
  );
};

export default TaxCrud;